module.exports = __webpack_public_path__ + "img/04.6cb629ae.jpg";